import { createRouter, createWebHistory } from 'vue-router';
import mallRoutes from './mallRoutes';
import h5Routes from './h5Routes';
import Center from '@/layout/center.vue';
import CenterH5 from '@/layout/h5Center.vue';
import RegisterAgree from '@/views/registerAgree.vue';
const router = createRouter({
  history: createWebHistory("/gsm"),
  routes: [
    {
      name: '商城',
      path: '/',
      component: Center,
      children: mallRoutes
    },
        {
      name: '1+3门户h5',
      path: '/h5',
      component: CenterH5,
      redirect: '/h5/index',
      children: h5Routes
    }, 
    {
      name: { label: "隐私政策声明", moduleName: "隐私政策声明" },
      path: "/privacyPolicy", component: RegisterAgree
    },
    {
      name: { label: "法律声明", moduleName: "法律声明" },
      path: "/legaNotice", component: RegisterAgree
    }
  ],
  
  scrollBehavior() {
    return { top: 0 };
  },
});
/**
 * 判断是否为移动端
 */
const checkIsMobile = () => {
  const width = window.innerWidth;
  const ua = navigator.userAgent.toLowerCase();
  const isMobileUA = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(ua);
  return width < 1280 || isMobileUA;
};

router.beforeEach((to, from, next) => {
  const isMobile = checkIsMobile();
  const isH5Path = to.path.startsWith('/h5');

  // 1. 如果是移动端，但访问的是 PC 路径
  if (isMobile && !isH5Path) {
    // 将路径前缀加上 /h5，例如 /home -> /h5/home
    const targetPath = to.path === '/' ? '/h5/index' : `/h5${to.path}`;
    return next(targetPath);
  }

  // 2. 如果是 PC 端，但访问的是 H5 路径
  if (!isMobile && isH5Path) {
    // 将路径中的 /h5 去掉，例如 /h5/home -> /home
    const targetPath = to.path.replace(/^\/h5/, '') || '/';
    return next(targetPath);
  }

  next();
});
console.log(router,'router')
export default router;


